import React from 'react';
import { Button } from './ui/button';
import { Sparkles, ArrowRight } from 'lucide-react';

export const CTABanner = ({ onOpenPopup }) => {
  return (
    <section className="relative py-12 bg-gradient-to-r from-primary via-blue-700 to-orange-600 overflow-hidden">
      {/* Animated background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }} />
      </div>
      
      {/* Floating shapes */}
      <div className="absolute top-0 left-1/4 w-32 h-32 bg-white/10 rounded-full blur-2xl animate-pulse"></div>
      <div className="absolute bottom-0 right-1/4 w-40 h-40 bg-white/10 rounded-full blur-2xl animate-pulse" style={{ animationDelay: '1s' }}></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            {/* Left content */}
            <div className="text-center md:text-left flex-1">
              <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm rounded-full px-4 py-1.5 mb-4">
                <Sparkles className="text-yellow-300" size={18} />
                <span className="text-white text-sm font-semibold">Limited Time Offer</span>
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">
                Ready to Protect Your Brand?
              </h3>
              <p className="text-white/90 text-base md:text-lg">
                Get started today with our expert trademark registration services
              </p>
            </div>

            {/* Right CTA */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                onClick={onOpenPopup}
                className="bg-white text-primary hover:bg-gray-100 h-12 px-8 text-base font-semibold shadow-xl hover:shadow-2xl transition-all hover:scale-105"
              >
                Get Free Consultation
                <ArrowRight className="ml-2" size={18} />
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom wave */}
      <div className="absolute -bottom-1 left-0 right-0">
        <svg viewBox="0 0 1440 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full">
          <path d="M0 60L60 55C120 50 240 40 360 35C480 30 600 30 720 32C840 35 960 40 1080 42C1200 45 1320 45 1380 45L1440 45V60H1380C1320 60 1200 60 1080 60C960 60 840 60 720 60C600 60 480 60 360 60C240 60 120 60 60 60H0V60Z" fill="white" fillOpacity="0.1"/>
        </svg>
      </div>
    </section>
  );
};
